import { Navigate, Route, Routes } from 'react-router-dom'
import { ScrollToTop } from './components/ScrollToTop.js'
import { PublicLayout } from './routes/public/PublicLayout.js'
import { HomePage } from './routes/public/HomePage.js'
import { LearnPage } from './routes/public/LearnPage.js'
import { AboutPage } from './routes/public/AboutPage.js'
import { ProductsPage } from './routes/public/ProductsPage.js'
import { ContactPage } from './routes/public/ContactPage.js'
import { BookingPage } from './routes/public/BookingPage.js'
import { LegalPage } from './routes/public/LegalPage.js'
import { StudioLayout } from './routes/studio/StudioLayout.js'
import { InvitePage } from './routes/student/InvitePage.js'
import { StudentLayout } from './routes/student/StudentLayout.js'
import { StudentHomePage } from './routes/student/StudentHomePage.js'
import { StudentAccountPage } from './routes/student/StudentAccountPage.js'
import { CoursePage, MyCoursesPage } from './routes/student/CoursePage.js'
import { LessonPlayer } from './routes/student/player/LessonPlayer.js'
import { ReviewPage } from './routes/student/ReviewPage.js'
import { HomeworkPage } from './routes/student/HomeworkPage.js'
import { LessonHomeworkPage } from './routes/student/LessonHomeworkPage.js'
import { GlossaryPage } from './routes/student/GlossaryPage.js'
import { LessonsPage } from './routes/student/LessonsPage.js'
import { CoursesAdminPage } from './routes/studio/CoursesAdminPage.js'
import { LoginPage } from './routes/studio/LoginPage.js'
import { DashboardPage } from './routes/studio/DashboardPage.js'
import { CalendarPage } from './routes/studio/CalendarPage.js'
import { OffersPage } from './routes/studio/OffersPage.js'
import { ProductsAdminPage } from './routes/studio/ProductsAdminPage.js'
import { LeadsPage } from './routes/studio/LeadsPage.js'
import { AccountPage } from './routes/studio/AccountPage.js'
import { ClientsPage } from './routes/studio/ClientsPage.js'
import { ClientDetailPage } from './routes/studio/ClientDetailPage.js'
import { AccountingPage } from './routes/studio/AccountingPage.js'
import { SitePage } from './routes/studio/SitePage.js'
import { TeacherLessonPage } from './routes/studio/TeacherLessonPage.js'

/**
 * The public site exists once per language: `/` is Polish, `/uk/...` and
 * `/ru/...` carry a prefix. Slugs stay Polish in every language — they are
 * part of the brand and the SEO history, and the server-side meta injection
 * (apps/api/src/ssr/meta.ts) parses the same `locale/slug` pair.
 */
function publicPages() {
  return (
    <>
      <Route index element={<HomePage />} />
      <Route path="o-mnie" element={<AboutPage />} />
      <Route path="ucz-sie-ze-mna" element={<LearnPage />} />
      <Route path="produkty" element={<ProductsPage />} />
      <Route path="rezerwacja" element={<BookingPage />} />
      <Route path="kontakt" element={<ContactPage />} />
      <Route path="regulamin" element={<LegalPage slug="regulamin" />} />
      <Route path="prywatnosc" element={<LegalPage slug="prywatnosc" />} />
      <Route path="cookies" element={<LegalPage slug="cookies" />} />
    </>
  )
}

export function App() {
  return (
    <>
    <ScrollToTop />
    <Routes>
      {/* Diana's login lives at /login — short enough to type from memory. */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/studio/login" element={<Navigate to="/login" replace />} />

      <Route path="/studio" element={<StudioLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="kalendarz" element={<CalendarPage />} />
        <Route path="klienci" element={<ClientsPage />} />
        <Route path="klienci/:id" element={<ClientDetailPage />} />
        <Route path="kursy" element={<CoursesAdminPage />} />
        <Route path="rozliczenia" element={<AccountingPage />} />
        <Route path="cennik" element={<OffersPage />} />
        <Route path="produkty" element={<ProductsAdminPage />} />
        <Route path="wiadomosci" element={<LeadsPage />} />
        <Route path="strona" element={<SitePage />} />
        <Route path="konto" element={<AccountPage />} />
        <Route path="lekcja/:slug/:lessonSlug" element={<TeacherLessonPage />} />
      </Route>

      {/*
        The student's area. Deliberately outside the locale prefix: the
        language comes from their account, not the URL — see StudentLayout.
      */}
      <Route path="/zaproszenie/:token" element={<InvitePage />} />
      <Route path="/panel" element={<StudentLayout />}>
        <Route index element={<StudentHomePage />} />
        <Route path="kurs" element={<MyCoursesPage />} />
        <Route path="kurs/:slug" element={<CoursePage />} />
        <Route path="kurs/:slug/:lessonSlug" element={<LessonPlayer />} />
        <Route path="kurs/:slug/:lessonSlug/zadanie" element={<LessonHomeworkPage />} />
        <Route path="zadania" element={<HomeworkPage />} />
        <Route path="slownik" element={<GlossaryPage />} />
        <Route path="lekcje" element={<LessonsPage />} />
        <Route path="powtorki" element={<ReviewPage />} />
        <Route path="konto" element={<StudentAccountPage />} />
      </Route>

      {/* Public site — one tree per language. */}
      <Route path="/" element={<PublicLayout locale="pl" />}>
        {publicPages()}
      </Route>
      <Route path="/uk" element={<PublicLayout locale="uk" />}>
        {publicPages()}
      </Route>
      <Route path="/ru" element={<PublicLayout locale="ru" />}>
        {publicPages()}
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  )
}
